import './Groomer.scss';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  createTeamUser,
  editTeamUser,
  getTeamUser,
  getTeamUsers,
  uploadUserAvatar,
} from 'actions/user';
import Button from 'atoms/button';
import { clearForm, initializeForm } from 'store/reducers/groomerForm';
import { closeDrawer } from 'store/reducers/ui';
import { catAndDogTypeId, catTypeId, dogTypeId } from 'util/constants';

import Details from './GroomerCreate/Details';
import Services from './GroomerCreate/Services';
import GroomerEdit from './GroomerEdit';

export default function GroomerDrawer() {
  const dispatch = useDispatch();
  const {
    servicedAnimals,
    firstName,
    lastName,
    phone,
    countryCodeId,
    email,
    services,
    role,
  } = useSelector((state) => state.groomerForm);
  const { uuid, type: drawerType } = useSelector((state) => state.ui.drawer);
  const { groomers } = useSelector((state) => state.groomers);
  const [userImage, setUserImage] = useState(null);
  const selectedGroomer = groomers.filter(
    (groomer) => groomer.user.uuid === uuid
  )?.[0];
  const canContinue =
    firstName &&
    lastName &&
    phone &&
    countryCodeId &&
    email &&
    services.filter((el) => el.name).length > 0 &&
    servicedAnimals.length > 0;

  useEffect(() => {
    if (selectedGroomer) {
      dispatch(getTeamUser(selectedGroomer.user.uuid)).then(
        ({ data, success }) => {
          if (success) {
            dispatch(initializeForm(data.data));
          }
        }
      );
    } else {
      dispatch(clearForm());
    }
  }, []);

  const saveImage = (image) => {
    setUserImage(image);
  };

  const onSave = () => {
    const body = {
      firstName,
      lastName,
      email,
      countryCodeId: countryCodeId.id,
      phoneNumber: phone,
      roleId: role?.id,
      animalTypeIds:
        servicedAnimals[0].id === catAndDogTypeId
          ? [catTypeId, dogTypeId]
          : [servicedAnimals[0].id],
      services: services
        .filter((service) => service.name)
        .map((service) => ({
          uuid: service.uuid,
          durationMinutes: service.durationMinutes?.id,
        })),
    };
    if (selectedGroomer) {
      editExistingGroomer(body);
    } else {
      createNewGroomer(body);
    }
  };

  const editExistingGroomer = async (body) => {
    if (userImage) {
      await dispatch(
        uploadUserAvatar({ body: userImage, uuid: selectedGroomer.user.uuid })
      );
    }
    dispatch(editTeamUser(body, selectedGroomer.user.uuid)).then(
      ({ success }) => {
        if (success) successActions();
      }
    );
  };

  const createNewGroomer = async (body) => {
    dispatch(createTeamUser(body)).then(({ success, data }) => {
      if (success) {
        if (userImage) {
          dispatch(
            uploadUserAvatar({ body: userImage, uuid: data.data.uuid })
          ).then(({ success }) => {
            if (success) successActions();
          });
        } else {
          successActions();
        }
      }
    });
  };

  const successActions = async () => {
    dispatch(getTeamUsers());
    dispatch(closeDrawer());
  };

  if (drawerType === 'groomer-edit') {
    return <GroomerEdit onSave={onSave} saveImage={saveImage} />;
  }

  return (
    <div className="payment-drawer flex-column align-end">
      <div className="w-100">
        <h2 className="mb-25 f26">Add groomer</h2>
        <Details saveImage={saveImage} />
        <Services />
        <Button
          text="Save"
          onClick={onSave}
          size="medium"
          className="mt-12"
          variant={canContinue ? 'default' : 'disabled'}
        />
      </div>
    </div>
  );
}
